import type { CityConfig } from "../city-template/types";

export const gardinerConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Kennebec County Clerk", href: "https://www.kennebeccounty.org/", description: "Kennebec County Clerk — marriage license issuance" },
    { label: "Divorce Records — Kennebec County Clerk", href: "https://www.kennebeccounty.org/", description: "Kennebec County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Gardiner",
  state: "Maine",
  stateAbbr: "ME",
  slug: "gardiner",
  route: "/cities/gardiner",
  title: "Emergency Passport Gardiner, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Gardiner, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Gardiner, Augusta, Randolph, Pittston, and Kennebec River Valley travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Gardiner, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Gardiner and Kennebec River Valley travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Gardiner%20Maine%20historic%20small%20city%20along%20the%20Kennebec%20River%2C%20Victorian-era%20architecture%20downtown%2C%20handsome%20brick%20commercial%20buildings%20on%20Water%20Street%20with%20river%20visible%20in%20background%2C%20New%20England%20autumn%20light%2C%20charming%20river%20town%20atmosphere%2C%20professional%20photography%2C%20no%20people%20or%20visible%20text%2C%20golden%20afternoon%20light%20reflecting%20on%20the%20Kennebec%20River&width=1800&height=700&seq=gardiner-me-hero-001&orientation=landscape",
  heroImageAlt: "Gardiner Maine historic Victorian downtown along the Kennebec River",
  geoPosition: "44.2320;-69.7745",
  geoPlacename: "Gardiner, Maine",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 165 miles (3 hours) from Gardiner, ME",
  },
  nearbyCitiesZips: [
    { name: "Downtown Gardiner", zips: "04345" },
    { name: "Augusta", zips: "04330" },
    { name: "Randolph", zips: "04346" },
    { name: "Pittston", zips: "04345" },
    { name: "Hallowell", zips: "04347" },
    { name: "Chelsea", zips: "04330" },
    { name: "Litchfield", zips: "04350" },
    { name: "West Gardiner", zips: "04345" },
    { name: "Richmond", zips: "04357" },
    { name: "Farmingdale", zips: "04344" },
    { name: "Readfield", zips: "04355" },
    { name: "Dresden", zips: "04342" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Gardiner departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Augusta", route: "/cities/augusta-me" },
    { name: "Emergency passport help in Portland", route: "/cities/portland-me" },
    { name: "Urgent passport services in Waterville", route: "/cities/waterville" },
    { name: "Same-day passport help in Lewiston", route: "/cities/lewiston" },
    { name: "Expedited passport services in Bath", route: "/cities/bath" },
    { name: "Passport courier services in Brunswick", route: "/cities/brunswick" },
    { name: "Rush passport help in South Portland", route: "/cities/south-portland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Gardiner, Maine remotely via secure courier. We do not have a walk-in office in Gardiner — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Gardiner travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving the Kennebec River Valley and surrounding areas",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Gardiner and the surrounding Kennebec River Valley. From historic Water Street downtown to the riverside neighborhoods along the Kennebec — we help Gardiner travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Gardiner neighborhoods and nearby towns including Augusta, Randolph, Pittston, Hallowell, Chelsea, West Gardiner, Richmond, and Farmingdale. If you are in the Kennebec River Valley, we have you covered.",
  howItWorksIntro: "Most Gardiner travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Gardiner is a historic river town close to Augusta's government offices, but passport acceptance facilities still have strict requirements. Here are the most common mistakes we see from Gardiner-area travelers.",
  testimonialsIntro: "Gardiner travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Gardiner? Here are the most common ones we hear from Kennebec River Valley travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Gardiner international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Patricia H.",
      location: "Gardiner, ME",
      rating: 5,
      text: "My husband and I had a river cruise in Europe coming up and my passport was expired. Fast Passport Center got my renewal done in 4 days. I shipped from the Gardiner post office and everything went perfectly.",
      service: "Passport Renewal",
    },
    {
      name: "Donald C.",
      location: "Randolph, ME",
      rating: 5,
      text: "Lost my passport a week before a business trip to Montreal. Fast Passport Center handled the DS-64 form and had my replacement ready in 2 days. Incredible service for a small town like ours.",
      service: "Lost Passport",
    },
    {
      name: "Susan M.",
      location: "Hallowell, ME",
      rating: 5,
      text: "Needed an emergency passport for a family emergency abroad. Fast Passport Center was the only service that could actually deliver in 24 hours. Professional and compassionate throughout.",
      service: "Emergency Passport",
    },
    {
      name: "Robert K.",
      location: "West Gardiner, ME",
      rating: 5,
      text: "Child passport for our daughter — needed both parents to show up but had everything else wrong. Fast Passport Center walked us through every requirement. Got her passport in 5 days, well in time for our cruise.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "gardiner-1",
      name: "Gardiner Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "289 Water St",
      city: "Gardiner",
      state: "ME",
      zip: "04345",
      phone: "(207) 582-4921",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Gardiner",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Limited passport acceptance hours. Call ahead to confirm availability and book appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "gardiner-2",
      name: "Hallowell City Hall",
      type: "Municipal Passport Acceptance",
      address: "1 Winthrop St",
      city: "Hallowell",
      state: "ME",
      zip: "04347",
      phone: "(207) 623-4021",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "3 miles from downtown Gardiner",
      website: "https://www.hallowell.org/",
      websiteLabel: "Hallowell City Hall",
      notes: "Convenient for Hallowell and Chelsea residents. Appointment preferred.",
      icon: "ri-government-line",
    },
    {
      id: "gardiner-3",
      name: "Augusta Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40 Western Ave",
      city: "Augusta",
      state: "ME",
      zip: "04330",
      phone: "(207) 622-3139",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from downtown Gardiner",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment slots. Popular for Gardiner and Randolph residents.",
      icon: "ri-mail-line",
    },
    {
      id: "gardiner-4",
      name: "Richmond Town Office",
      type: "Town Office Passport Acceptance",
      address: "1 Main St",
      city: "Richmond",
      state: "ME",
      zip: "04357",
      phone: "(207) 737-4305",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles from Gardiner",
      website: "https://www.richmondmaine.com/",
      websiteLabel: "Richmond Town Office",
      notes: "Good option for Richmond and Bowdoinham residents. Call ahead to schedule.",
      icon: "ri-government-line",
    },
    {
      id: "gardiner-5",
      name: "Litchfield Town Office",
      type: "Town Office Passport Acceptance",
      address: "72 Plains Rd",
      city: "Litchfield",
      state: "ME",
      zip: "04350",
      phone: "(207) 268-4721",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "12 miles from Gardiner",
      website: "https://www.litchfieldmaine.us/",
      websiteLabel: "Litchfield Town Office",
      notes: "Limited hours. Call ahead to confirm passport acceptance days.",
      icon: "ri-government-line",
    },
    {
      id: "gardiner-6",
      name: "Waterville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Elm Plaza",
      city: "Waterville",
      state: "ME",
      zip: "04901",
      phone: "(207) 872-5601",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles from Gardiner",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good backup option with reliable appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Maine photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Gardiner acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Gardiner applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Gardiner families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Gardiner travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Gardiner or Augusta." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Gardiner address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Gardiner, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Gardiner in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Gardiner travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Gardiner, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Gardiner residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Gardiner, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Gardiner with no office visit required. We serve all Gardiner neighborhoods and the surrounding Kennebec River Valley. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How close is Gardiner to the Boston Passport Agency?",
      a: "Gardiner is approximately 165 miles from the Boston Passport Agency — about a 3-hour drive. With Fast Passport Center, you avoid that trip entirely. We courier your documents directly to State Department facilities, saving you time and stress.",
    },
    {
      q: "What acceptance facilities are near Gardiner, Maine?",
      a: "Options near Gardiner include the Gardiner Post Office (04345), Hallowell City Hall (04347), and the Augusta Main Post Office (04330). Augusta offers more appointment slots and is only 8 miles away. We help you find the most convenient location.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "What if I live in Randolph, Pittston, or Hallowell?",
      a: "We serve all of southern Kennebec County including Gardiner, Randolph, Pittston, Hallowell, West Gardiner, Chelsea, and Richmond. Our overnight shipping labels work from any UPS location, so your exact address doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Gardiner?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline and needs.",
    },
    {
      q: "What documents do I need for a first-time passport in Gardiner?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Gardiner?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Gardiner families through the entire process and help schedule acceptance clerk appointments.",
    },
    {
      q: "Is there a UPS Store near Gardiner for shipping documents?",
      a: "The closest UPS Store is in Augusta, about 8 miles from Gardiner. We provide a prepaid overnight label — just drop your package at any UPS location or schedule a pickup. USPS Priority Mail Express is also an option from the Gardiner Post Office.",
    },
    {
      q: "Can I get passport photos taken in Gardiner?",
      a: "The CVS Pharmacy and Rite Aid in Gardiner both offer passport photo services. The Walmart in Augusta also has a photo center. We recommend getting photos taken with a white or off-white background and reviewing them with us before your acceptance clerk visit.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Gardiner", address: "289 Water St, Gardiner, ME 04345", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Rite Aid — Gardiner", address: "290 Water St, Gardiner, ME 04345", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "Walmart Photo Center — Augusta", address: "1 Walmart Way, Augusta, ME 04330", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Augusta", address: "11 Whitten Rd, Augusta, ME 04330", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Augusta", address: "280 State St, Augusta, ME 04330", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Augusta", address: "294 Western Ave, Augusta, ME 04330", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Hallowell", address: "130 Water St, Hallowell, ME 04347", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "Walgreens — Waterville", address: "10 Concourse, Waterville, ME 04901", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    {
      name: "BMV — Augusta",
      address: "19 Anthony Ave, Augusta, ME 04330",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. Online appointment booking available. 8 miles from Gardiner.",
      featured: true,
    },
    {
      name: "BMV — Gardiner (Kiosk)",
      address: "289 Water St, Gardiner, ME 04345",
      hours: "Mon–Fri: 9AM–4PM",
      note: "Limited services only. Full transactions require Augusta location.",
      featured: false,
    },
    {
      name: "BMV — Waterville",
      address: "1 Elm Plaza, Waterville, ME 04901",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Second nearest full-service BMV. 25 miles from Gardiner.",
      featured: false,
    },
    {
      name: "BMV — Lewiston",
      address: "33 College St, Lewiston, ME 04240",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Androscoggin County option. About 30 miles from Gardiner.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "60 miles from Gardiner (1 hour 10 min)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with direct flights to major U.S. hubs, Florida, and Canada. The primary international departure point for Kennebec River Valley travelers.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: true,
    },
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "80 miles from Gardiner (1.5 hours)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport. Good alternative for northern Maine connections and seasonal international flights.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "165 miles from Gardiner (3 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many southern Maine travelers connect through Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};